// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"0f42d414","261":"93ef8cce","374":"1731f345","453":"253c9c94","481":"ada848fe","493":"6fbd02e4","567":"497b1070","709":"9173db83","761":"1d24b3b5","890":"e0d6652c","989":"175b31a7"}[chunkId] + ".chunk.js";
};